import { render } from "./TalkiiFooter.vue?vue&type=template&id=394e6dc0"
import script from "./TalkiiFooter.vue?vue&type=script&lang=js"
export * from "./TalkiiFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__